
import axios from 'axios';
import {StringService, RunConfigService} from '@nuskin/ns-util';
import {unflatten} from '../utils/flatten.js';

/**
 * @param {VueI18n} i18n - A instance of VueI18n.
 * @param {string} locale - A locale in the format `${language}_${Region}`.
 * @return {Promise}
 */
export async function loadLocalization(i18n, locale) {
    const application = 'signup';
    locale = locale || i18n.locale;
    try {
        const messages = await StringService.getApplicationStrings(application, {}, locale);
        i18n.mergeLocaleMessage(locale, unflatten(messages));
    } catch (err) /* istanbul ignore next */ {
        console.error('error loading localization', err);
        throw err;
    }
}

/**
 * @param {string} market - A market in the format `${region}`.
 * @return {Promise}
 */
export async function isEquinoxMarket(market) {
    const baseUrl = RunConfigService.getBaseUrl();
    const endpoint = `${baseUrl}/content/localization/signup/eq-signup-enabled.service.json`;
    try {
        const data = await axios.get(endpoint);
        return /^true$/i.test(data?.data[market]);
    } catch (error) {
        console.error(error.message);
    }
}
